.progress {
  min-width: 50px;
  width: 100%;
  height: 12px;
}
